import * as React from 'react';

import { Responsive } from '@cian/ui-kit';

import { DesktopPageContainer, MobilePageContainer } from './views';
import { MyHomeMobilePage, MyHomeDesktopPage } from './views/MyHome';
import { useCustomPopHistory, useDataLoadingOtherBlocks } from './utils';
import { NotificatorContainer } from '../NotificatorContainer';
import { useSelector } from 'react-redux';
import { selectDealType, selectIsMyHome } from '../../selectors/page';
import { useSendBlocksExists } from '../../utils/teaser/useSendBlocksExists';

export function CalculatorPageContainer() {
  const dealType = useSelector(selectDealType);
  useDataLoadingOtherBlocks();
  useCustomPopHistory();
  const sendBlocksExists = useSendBlocksExists();

  React.useEffect(() => {
    sendBlocksExists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealType]);

  const isMyHome = useSelector(selectIsMyHome);

  const DesktopView = isMyHome ? MyHomeDesktopPage : DesktopPageContainer;
  const MobileView = isMyHome ? MyHomeMobilePage : MobilePageContainer;

  return (
    <>
      <Responsive desktop>
        <DesktopView />
      </Responsive>
      <Responsive phone tablet>
        <MobileView />
      </Responsive>

      <NotificatorContainer />
    </>
  );
}
